import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=16c8f58d&scoped=true"
import script from "./UserSummary.vue?vue&type=script&lang=ts"
export * from "./UserSummary.vue?vue&type=script&lang=ts"
import style0 from "./UserSummary.vue?vue&type=style&index=0&id=16c8f58d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8f58d",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/table/user-summary.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ftable%2FUserSummary.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports